/* ==============================================================================================
 * [ACCESS] TBA PAGE
 * ============================================================================================== */

var Sushi;

(function (Sushi, Plugins) {
	"use strict";

	/** @type {HTMLFormElement} */
	var form = document.querySelector("[data-feature=tbaForm]");

	if (!form) {
		return;
	}

	/**
	 * @param {number} from
	 * @param {number} to
	 * @return {Array<Object>}
	 */
	function couponRange(from, to) {
		var rateArr = [];
		var rateStr, rateValue;

		for (var i = from; i <= to; i += 0.25) {
			rateStr = i.toFixed(2).toString();

			rateValue = rateStr.split(".");

			if (rateValue[0] < 10) {
				rateValue[0] = "0".concat(rateValue[0]);
			}

			rateArr.push({
				value: rateValue[0].concat((rateValue[1] / 25).toString()),
				label: rateStr.concat("%"),
			});
		}

		return rateArr;
	}

	/**
	 * @param {Array<Object>} optionList
	 * @param {HTMLSelectElement|Element} selectElement
	 * @return {void}
	 */
	function addOptionsToSelect(optionList, selectElement) {
		var opt;

		for (var i = 0, n = optionList.length; i < n; i++) {

			/** @type {HTMLOptionElement} */
			opt = document.createElement("option");
			opt.value = optionList[i].value;
			opt.text = optionList[i].label;

			selectElement.add(opt);
		}

		Sushi.Events(selectElement).trigger("change");
	}

	/**
	 * @param {HTMLSelectElement|Element} selectElement
	 * @return {void}
	 */
	function resetSelectValue(selectElement) {
		if (selectElement.value) {
			selectedOption[selectElement.getAttribute("data-input")] = null;
			selectElement.value = "";
			Sushi.Events(selectElement).trigger("change");
		}
	}

	/**
	 * @param {HTMLInputElement|Element} inputElement
	 * @return {void}
	 */
	function resetInputValue(inputElement) {
		if (inputElement.value) {
			inputElement.value = "";
			Sushi.Events(inputElement).trigger("FloatingLabel.change");
		}
	}

	/**
	 * @param {HTMLSelectElement|Element} selectElement
	 * @return {void}
	 */
	function removeSelectOptions(selectElement) {
		resetSelectValue(selectElement);
		Sushi.Util.removeSelectOptions(selectElement);
		Sushi.Events(selectElement).trigger("change");
	}

	/**
	 * @param {HTMLSelectElement|Element} selectElement
	 * @return {void}
	 */
	function disableSelect(selectElement) {
		selectElement.parentNode.classList.add("c-select--disabled");
		selectElement.disabled = true;
		Sushi.Events(selectElement).trigger("change");
	}

	/**
	 * @param {HTMLSelectElement|Element} selectElement
	 * @return {void}
	 */
	function enableSelect(selectElement) {
		selectElement.parentNode.classList.remove("c-select--disabled");
		selectElement.disabled = false;
		Sushi.Events(selectElement).trigger("change");
	}

	/**
	 * @param {HTMLSelectElement|Element} selectElement
	 * @return {HTMLOptionElement}
	 */
	function getSelectedOption(selectElement) {
		for (var i = 0; i < selectElement.options.length; i++) {
			if (selectElement.options[i].selected === true) {
				return selectElement.options[i];
			}
		}
	}

	/**
	 * @return {{ value: string, label: string, product: Array<Object> }}
	 */
	function getSelectedAgencyData() {
		for (var i = 0, n = formValues.agency.length; i < n; i++) {
			if (
				selectedOption.agency
				&& formValues.agency[i].label === selectedOption.agency.innerText
			) {
				return formValues.agency[i];
			}
		}
	}

	/**
	 * @return {{ value: string, label: string, yearsToMaturity: Array<Object> }}
	 */
	function getSelectedProductData() {
		var selectedAgency = getSelectedAgencyData();

		if (selectedAgency) {
			for (var i = 0, n = selectedAgency.product.length; i < n; i++) {
				if (
					selectedOption.product
					&& selectedAgency.product[i].value === selectedOption.product.value
				) {
					return selectedAgency.product[i];
				}
			}
		}
	}

	/**
	 * @return {{ value: string, label: string, coupon: Array<Object> }}
	 */
	function getSelectedYearsMaturityData() {
		var selectedProduct = getSelectedProductData();

		if (selectedProduct) {
			for (var i = 0, n = selectedProduct.yearsMaturity.length; i < n; i++) {
				if (
					selectedOption.yearsMaturity
					&& selectedProduct.yearsMaturity[i].value === selectedOption.yearsMaturity.value
				) {
					return selectedProduct.yearsMaturity[i];
				}
			}
		}
	}

	/**
	 * @return {void}
	 */
	function resetFieldsOnInputChange(triggerElement) {
		resetSelectValue(formFields.agency);
		resetSelectValue(formFields.settleMonth);

		if (triggerElement === formFields.isin) {
			resetInputValue(formFields.cusip);
		}
		else if (triggerElement === formFields.cusip) {
			resetInputValue(formFields.isin);
		}
	}

	var formValues = {
		agency: [
			{
				value: "R",
				label: "FHLMC",
				product: [
					{
						value: "FHLMC_02",
						label: "Gold Single Family",
						yearsMaturity: [
							{
								value: "FHLMC02_1",
								label: "5 Years",
								coupon: [
									{
										value: "031",
										label: "3.25%",
									},
								].concat(couponRange(10.25, 11)),
							},
							{
								value: "FHLMC02_3",
								label: "10 Years",
								coupon: couponRange(3, 11),
							},
							{
								value: "FHLMC02_4",
								label: "15 Years",
								coupon: couponRange(3, 13),
							},
							{
								value: "FHLMC02_5",
								label: "20 Years",
								coupon: couponRange(3, 11),
							},
							{
								value: "FHLMC02_6",
								label: "30 Years",
								coupon: couponRange(3, 13),
							},
							{
								value: "FHLMC02_7",
								label: "40 Years",
								coupon: couponRange(5, 7.75),
							},
						],
					},
					{
						value: "FHLMC_07",
						label: "Gold Balloon",
						yearsMaturity: [
							{
								value: "FHLMC07_1",
								label: "5 Years",
								coupon: couponRange(3, 11),
							},
							{
								value: "FHLMC07_2",
								label: "7 Years",
								coupon: couponRange(3.25, 10.75),
							},
						],
					},
					{
						value: "FHLMC_16",
						label: "ARMS",
						yearsMaturity: [
							{
								value: "FHLMC16_4",
								label: "15 Years",
								coupon: couponRange(1, 13),
							},
							{
								value: "FHLMC16_5",
								label: "20 Years",
								coupon: couponRange(1, 13),
							},
							{
								value: "FHLMC16_6",
								label: "30 Years",
								coupon: couponRange(1, 13),
							},
							{
								value: "FHLMC16_7",
								label: "40 Years",
								coupon: couponRange(1, 13),
							},
						],
					},
					{
						value: "FHLMC_50",
						label: "Interest Only Mortgages",
						yearsMaturity: [
							{
								value: "FHLMC_50_3",
								label: "10 Years",
								coupon: couponRange(1, 13),
							},
							{
								value: "FHLMC_50_4",
								label: "15 Years",
								coupon: couponRange(1, 13),
							},
							{
								value: "FHLMC_50_5",
								label: "20 Years",
								coupon: couponRange(1, 13),
							},
							{
								value: "FHLMC_50_6",
								label: "30 Years",
								coupon: couponRange(1, 13),
							},
						],
					},
					{
						value: "FHLMC_60",
						label: "Single Family Mortgage - Fixed Rate Not-Good Delivery",
						yearsMaturity: [
							{
								value: "FHLMC60_2",
								label: "7 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "FHLMC60_3",
								label: "10 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "FHLMC60_4",
								label: "20 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "FHLMC60_6",
								label: "30 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "FHLMC60_7",
								label: "40 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "FHLMC60_0",
								label: "Other",
								coupon: couponRange(0.25, 13),
							},
						],
					},
				],
			},
			{
				value: "F",
				label: "FNMA",
				product: [
					{
						value: "FNMA_01",
						label: "Single Family Mortgage",
						yearsMaturity: [
							{
								value: "FNMA01_1",
								label: "5 Years",
								coupon: couponRange(3, 3.75),
							},
							{
								value: "FNMA01_2",
								label: "7 Years",
								coupon: couponRange(3, 3.25).concat(couponRange(10.25, 11)),
							},
							{
								value: "FNMA01_7",
								label: "40 Years",
								coupon: couponRange(3, 7.75),
							},
						],
					},
					{
						value: "FNMA_06",
						label: "Balloon",
						yearsMaturity: [
							{
								value: "FNMA06_2",
								label: "7 Years",
								coupon: couponRange(3, 11),
							},
						],
					},
					{
						value: "FNMA_11",
						label: "11th Dist COFI",
						yearsMaturity: [
							{
								value: "FNMA11_6",
								label: "30 Years",
								coupon: [
									{ value: "011", label: "125 basis pts" },
								],
							},
						],
					},
					{
						value: "FNMA_16",
						label: "ARMS",
						yearsMaturity: [
							{
								value: "FNMA16_4",
								label: "15 Years",
								coupon: couponRange(1, 13),
							},
							{
								value: "FNMA16_5",
								label: "20 Years",
								coupon: couponRange(1, 13),
							},
							{
								value: "FNMA16_6",
								label: "30 Years",
								coupon: couponRange(1, 14),
							},
							{
								value: "FNMA16_7",
								label: "40 Years",
								coupon: couponRange(1, 14),
							},
						],
					},
					{
						value: "FNMA_50",
						label: "Interest Only Mortgages",
						yearsMaturity: [
							{
								value: "FNMA50_3",
								label: "10 Years",
								coupon: couponRange(1, 13),
							},
							{
								value: "FNMA50_4",
								label: "15 Years",
								coupon: couponRange(1, 13),
							},
							{
								value: "FNMA50_5",
								label: "20 Years",
								coupon: couponRange(1, 13),
							},
							{
								value: "FNMA50_6",
								label: "30 Years",
								coupon: couponRange(1, 13),
							},
						],
					},
					{
						value: "FNMA_56",
						label: "DUS Pools",
						yearsMaturity: [
							{
								value: "FNMA56_1",
								label: "5 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "FNMA56_2",
								label: "7 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "FNMA56_3",
								label: "10 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "FNMA56_4",
								label: "15 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "FNMA56_8",
								label: "18 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "FNMA56_5",
								label: "20 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "FNMA56_6",
								label: "30 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "FNMA56_7",
								label: "40 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "FNMA56_0",
								label: "Other",
								coupon: couponRange(0.25, 13),
							},
						],
					},
					{
						value: "FNMA_60",
						label: "Single Family Mortgage - Fixed Rate Not-Good Delivery",
						yearsMaturity: [
							{
								value: "FNMA60_2",
								label: "7 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "FNMA60_3",
								label: "10 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "FNMA60_4",
								label: "15 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "FNMA60_6",
								label: "30 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "FNMA60_7",
								label: "40 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "FNMA60_0",
								label: "Other",
								coupon: couponRange(0.25, 13),
							},
						],
					},
				],
			},
			{
				value: "N",
				label: "GNMA I",
				product: [
					{
						value: "GNMA_01",
						label: "Single Family Mortgage",
						yearsMaturity: [
							{
								value: "GNMA01_4",
								label: "15 Years",
								coupon: couponRange(3, 11),
							},
							{
								value: "GNMA01_6",
								label: "30 Years",
								coupon: couponRange(3, 15),
							},
						],
					},
					{
						value: "GNMA_03",
						label: "Single Family/GPM",
						yearsMaturity: [
							{
								value: "GNMA03_6",
								label: "30 Years",
								coupon: {
									value: "112",
									label: "11.50%",
								},
							},
						],
					},
					{
						value: "GNMA_13",
						label: "Seasoned",
						yearsMaturity: [
							{
								value: "GNMA13_6",
								label: "30 Years",
								coupon: couponRange(5, 11.50),
							},
						],
					},
					{
						value: "GNMA_54",
						label: "Project/Construction Loan",
						yearsMaturity: [
							{
								value: "GNMA54_2",
								label: "7 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "GNMA54_3",
								label: "10 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "GNMA54_4",
								label: "15 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "GNMA54_9",
								label: "35 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "GNMA54_7",
								label: "40 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "GNMA54_0",
								label: "Other",
								coupon: couponRange(0.25, 13),
							},
						],
					},
				],
			},
			{
				value: "H",
				label: "GNMA II",
				product: [
					{
						value: "GNMAII_01",
						label: "Single Family Mortgage",
						yearsMaturity: [
							{
								value: "GNMAII01_1",
								label: "5 Years",
								coupon: {
									value: "013",
									label: "1.75%",
								},
							},
							{
								value: "GNMAII01_4",
								label: "15 Years",
								coupon: couponRange(3, 10),
							},
							{
								value: "GNMAII01_5",
								label: "20 Years",
								coupon: {
									value: "013",
									label: "1.75%",
								},
							},
							{
								value: "GNMAII01_6",
								label: "30 Years",
								coupon: couponRange(3, 11.50),
							},
						],
					},
					{
						value: "GNMAII_16",
						label: "ARMS",
						yearsMaturity: [
							{
								value: "GNMAII16_6",
								label: "30 Years",
								coupon: couponRange(2.25, 11),
							},
						],
					},
					{
						value: "GNMAII_21",
						label: "Jumbos",
						yearsMaturity: [
							{
								value: "GNMAII21_4",
								label: "15 Years",
								coupon: couponRange(2, 11),
							},
							{
								value: "GNMAII21_6",
								label: "30 Years",
								coupon: couponRange(3, 10),
							},
						],
					},
					{
						value: "GNMAII_58",
						label: "HMBS - Reverse Mortgage",
						yearsMaturity: [
							{
								value: "GNMAII58_A",
								label: "50 Years",
								coupon: couponRange(0.25, 13),
							},
						],
					},
					{
						value: "GNMAII_60",
						label: "Single Family Mortgage – Fixed rate Not-Good Delivery",
						yearsMaturity: [
							{
								value: "GNMAII60_2",
								label: "7 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "GNMAII60_3",
								label: "10 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "GNMAII60_4",
								label: "15 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "GNMAII60_6",
								label: "30 Years",
								coupon: couponRange(0.25, 13),
							},
							{
								value: "GNMAII60_0",
								label: "Other",
								coupon: couponRange(0.25, 13),
							},
						],
					},
				],
			},
			{
				value: "F",
				label: "Uniform MBS",
				product: [
					{
						value: "UMBS_01",
						label: "Single Family Mortgage",
						yearsMaturity: [
							{
								value: "UMBS01_3",
								label: "10 Years",
								coupon: couponRange(1, 11),
							},
							{
								value: "UMBS01_4",
								label: "15 Years",
								coupon: couponRange(1, 11),
							},
							{
								value: "UMBS01_5",
								label: "20 Years",
								coupon: couponRange(1, 11),
							},
							{
								value: "UMBS01_6",
								label: "30 Years",
								coupon: couponRange(1, 15),
							},
						],
					},
				],
			},
		],
	};

	var formFields = {
		agency: form.querySelector("[data-input='agency']"),
		product: form.querySelector("[data-input='product']"),
		yearsMaturity: form.querySelector("[data-input='yearsMaturity']"),
		coupon: form.querySelector("[data-input='coupon']"),
		settleMonth: form.querySelector("[data-input='settleMonth']"),
		cusip: form.querySelector("[data-input='cusip']"),
		isin: form.querySelector("[data-input='isin']"),
	};

	/**
	 * @type {{}<HTMLOptionElement|Null>}
	 */
	var selectedOption = {
		agency: null,
		product: null,
		yearsMaturity: null,
		coupon: null,
		settleMonth: null,
	};

	/* form updates */

	/**
	 * Initialize the form events/listeners
	 */
	function initForm() {
		// Add agency values
		addOptionsToSelect(formValues.agency, formFields.agency);

		// Disable the other selects except for settleMonth
		disableSelect(formFields.product);
		disableSelect(formFields.yearsMaturity);
		disableSelect(formFields.coupon);

		// Update a select options based on the previous select value
		Sushi.Events(formFields.agency).on("Select.change", function () {

			// Reset text inputs when agency is changed
			formFields.cusip.value = "";
			formFields.isin.value = "";
			Sushi.Events(formFields.cusip).trigger("FloatingLabel.change");
			Sushi.Events(formFields.isin).trigger("FloatingLabel.change");

			disableSelect(formFields.product);
			removeSelectOptions(formFields.product);

			disableSelect(formFields.yearsMaturity);
			removeSelectOptions(formFields.yearsMaturity);

			disableSelect(formFields.coupon);
			removeSelectOptions(formFields.coupon);

			resetSelectValue(formFields.settleMonth);

			selectedOption.agency = getSelectedOption(formFields.agency);
			var selectedAgencyData = getSelectedAgencyData();

			if (selectedAgencyData) {
				enableSelect(formFields.product);
				addOptionsToSelect(selectedAgencyData.product, formFields.product);
			}
			else {
				selectedOption.agency = null;
			}
		});

		Sushi.Events(formFields.product).on("Select.change", function () {
			disableSelect(formFields.yearsMaturity);
			removeSelectOptions(formFields.yearsMaturity);

			disableSelect(formFields.coupon);
			removeSelectOptions(formFields.coupon);

			resetSelectValue(formFields.settleMonth);

			selectedOption.product = getSelectedOption(formFields.product);
			var selectedProductData = getSelectedProductData();

			if (selectedProductData) {
				enableSelect(formFields.yearsMaturity);
				addOptionsToSelect(selectedProductData.yearsMaturity, formFields.yearsMaturity);
			}
			else {
				selectedOption.product = null;
			}
		});

		Sushi.Events(formFields.yearsMaturity).on("Select.change", function () {
			disableSelect(formFields.coupon);
			removeSelectOptions(formFields.coupon);

			resetSelectValue(formFields.settleMonth);

			selectedOption.yearsMaturity = getSelectedOption(formFields.yearsMaturity);
			var selectedYearsData = getSelectedYearsMaturityData();

			if (selectedYearsData) {
				enableSelect(formFields.coupon);
				addOptionsToSelect(selectedYearsData.coupon, formFields.coupon);
			}
			else {
				selectedOption.yearsMaturity = null;
			}
		});

		Sushi.Events(formFields.coupon).on("Select.change", function () {
			resetSelectValue(formFields.settleMonth);
		});

		Sushi.Events([formFields.cusip, formFields.isin]).on("keydown", function (event) {
			resetFieldsOnInputChange(event.target);
		});
	}

	initForm();

	/* form reset */
	form.addEventListener("reset", function (event) {
		event.preventDefault();

		/** @type {NodeList<HTMLSelectElement>} */
		var selects = form.querySelectorAll("select");

		/** @type {NodeList<HTMLInputElement>} */
		var inputs = form.querySelectorAll("input");

		Sushi.Dom.forEach(selects, resetSelectValue);
		Sushi.Dom.forEach(inputs, resetInputValue);
	});

	/* copy to clipboard */
	var clipboardData = "data-clipboard-target";

	/** @type {HTMLButtonElement} */
	var clipboardTrigger = document.querySelector("[" + clipboardData + "]");

	/** @type {HTMLTextAreaElement} */
	var clipboardTarget = document.querySelector(clipboardTrigger.getAttribute(clipboardData));

	clipboardTrigger.addEventListener("click", function () {
		clipboardTarget.select();
		clipboardTarget.setSelectionRange(0, 99999);
		document.execCommand("copy");
	});

	/* form submit */
	var tbaResult = document.querySelector(".c-tba__result");
	var tbaResultSubmit = document.querySelector(".c-tba__resultSubmit");
	var tbaResultContent = document.querySelector(".c-tba__resultContent");
	var tbaResultContentWrapper = document.querySelector(".c-tba__resultContentWrapper");
	var tbaResultClose  = document.querySelector(".c-tba__resultClose");

	/**
	 * @return {void}
	 */
	function openResult() {
		if (screen.width < 1200) {
			tbaResultContentWrapper.style.maxHeight = tbaResultContent.offsetHeight + "px";
		}

		tbaResult.classList.add("c-tba__result--active");
	}

	/**
	 * @return {void}
	 */
	function closeResult() {
		if (screen.width < 1200) {
			tbaResultContentWrapper.style.maxHeight = "";
		}

		tbaResult.classList.remove("c-tba__result--active");
	}

	form.addEventListener("submit", function (event) {
		event.preventDefault();

		// Simulate AJAX call
		setTimeout(function () {
			openResult();
		}, 500);
	});

	tbaResultSubmit.addEventListener("click", function () {
		Sushi.Events(form).trigger("submit");
	});

	tbaResultClose.addEventListener("click", function () {
		closeResult();
	});

})(Sushi || (Sushi = {}), Sushi.Plugins || (Sushi.Plugins = {}));
